import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";

export function CollectionStrip() {
  const [cols, setCols] = useState([]);
  useEffect(() => { api.get("/collections").then((r) => setCols(r.data)); }, []);
  if (cols.length === 0) return null;
  const img = (c) => (c.banner_image?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${c.banner_image}` : c.banner_image);
  return (
    <section className="mb-16" data-testid="collection-strip">
      <div className="overline text-[#d4af37]">Seasonal collections</div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
        {cols.map((c) => (
          <Link key={c.id} to={`/collections/${c.slug}`} data-testid={`collection-card-${c.slug}`} className="relative overflow-hidden bg-[#0a192f] text-white h-44 flex items-end p-6 group">
            {img(c) && <img src={img(c)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:scale-105 transition-transform duration-700" />}
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f] to-transparent" />
            <div className="relative">
              {c.season_label && <div className="overline text-[#d4af37]">{c.season_label}</div>}
              <div className="font-serif text-2xl mt-1 leading-tight">{c.name}</div>
              <div className="text-xs text-white/70 mt-2 inline-flex items-center gap-1">{c.products.length} pieces <ArrowRight className="w-3 h-3" /></div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
